import themeGet from '@pyt/ui/utils/themeGet'
import { useRouter } from 'next/router'
import React, { useContext } from 'react'
import styled from 'styled-components'

import AppContext from '../../store/AppContext'
import getLocale from '../../utils/locale-helpers/getLocale'
// import Link from 'next/link'

const StyledLink = styled.a`
	display: inline-block;
	position: relative;
	color: ${themeGet('colors.white')};

	&:hover {
		color: rgba(255, 255, 255, 0.8);
	}

	&:after {
		content: '.';
		display: inline-block;
		line-height: 1;
		vertical-align: text-top;
		margin: 0 8px;
	}

	&:last-child {
		&:after {
			display: none;
		}
	}
`

const DotList = ({
	options,
	ca_index,
	onClickLink = () => false,
	className,
}) => {
	const router = useRouter()
	const [{ locale }] = useContext(AppContext)
	const currentLocale = getLocale({ router, locale })

	return (
		<>
			{options
				? options.map((item, opt_index) => {
						return (
							<StyledLink
								key={`des_key_${ca_index}_${opt_index}`}
								href={`${currentLocale ? `/${currentLocale}` : ''}${item.url}`}
								className={`n-tracker-destination ${
									className ? className : ''
								}`}
								onClick={() => onClickLink(item.name)}
								target="_blank"
							>
								{item.name}
							</StyledLink>
						)
				  })
				: null}
		</>
	)
}

export default DotList
